import withPermission from '../../containers/WithPermission';

export default (permission) => withPermission('Feeds', permission);
